<div class="user-service-detail">
  <div class="step-title strong">
    {{'games-header.form.lessons-placeholder-ok' | customLocale}}
  </div>
  <div class="subjects-list">
    <app-horizontal-scroll-menu [scrollList]="teachingSubjectsList"
                                (selectItem)="selectSubject($event)">
    </app-horizontal-scroll-menu>
  </div>

  <ng-template [ngIf]="selectedSubjectValue >=0">
    <ng-template ngFor let-userService [ngForOf]="services.items" let-idx="index" [ngForTrackBy]="trackUserServiceByFn">
      <div class="card-wrap">
        <app-user-service-card [service]="userService"
                               (selected)="selectUserService(idx)"
                               (openUserServiceInModal)="onToggleUserServiceInModal($event)"
                               mode="signup">
        </app-user-service-card>
      </div>
    </ng-template>
  </ng-template>
</div>
